export default {
	text: "{changedBy} renamed this KR <span class='text-strike'>{from}</span> to {to}",
};
